import { getPersonalUrl } from './articleData';
import { getIdType, isValidId } from './rn';

export const getQbUserInfo = (user) => {
  return {
    sQbid: user.qbid,
    sUserId: user.circleUserId || '',
    iIdType: user.qbUserType,
    sToken: user.token,
    // eTokenType: 5,
    sUnionId: user.uin,
  };
};

export const getAccountInfo = ({ docId, zimeitiId, fusionId, puin = '', mergePageInfo = {} }, currentChannel) => {
  const accountId = fusionId || zimeitiId || '';
  let url = '';
  if (typeof window !== 'undefined' && isValidId(accountId)) {
    const req = {
      userId: accountId,
      accountType: getIdType(accountId),
      from: '012',
      ch: currentChannel,
      docId,
    };
    url = getPersonalUrl(req);
  }
  return {
    puin,
    media_id: accountId,
    account_name: mergePageInfo.sName,
    account_icon: mergePageInfo.sIcon,
    jump_url: url,
  };
};

export const makeTagsInfo = (tags = []) => {
  const tagList = [];
  tags.forEach((item) => {
    tagList.push({
      tag_id: `${item.lTagId}`,
      tag_name: item.sTagName,
      weight: item.dNewTagScore,
    });
  });
  return tagList;
};
